import { render, staticRenderFns } from "./AddressLocationFields.vue?vue&type=template&id=5650789a&scoped=true"
import script from "./AddressLocationFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressLocationFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddressLocationFields.vue?vue&type=style&index=0&id=5650789a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650789a",
  null
  
)

export default component.exports